export const completeTargetURL = (targetURL: string): string => {
  const { protocol, host } = document.location;
  if (targetURL.startsWith('/')) {
    return `${protocol}//${host}${targetURL}`;
  }
  return targetURL;
};
